import cookie from "js-cookie";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  EnumStatisticChartGroupBy,
  EnumStatisticStatusGroup,
} from "../../../../../../server/routes/statistic/types";
import MenuButton from "../../../../components/MenuButton";
import { actionGroupByChange } from "../../../../store/statisticChart/actions";
import { useStatusGroup } from "../../StatusGroupProvider";
import useLoadingAnyDateChart from "../hooks/useLoadingAnyDateChart";
import { SelectorGroupByFC } from "./types";

const SelectorGroupBy: SelectorGroupByFC = () => {
  const { statusGroup } = useStatusGroup();
  const { groupBy, isLoading } = useSelector(
    ({
      statisticChart: {
        [statusGroup]: { groupBy, sending },
      },
    }) => ({
      groupBy,
      isLoading: sending,
    })
  );
  // const loading = useLoading();
  const loading = useLoadingAnyDateChart();
  const dispatch = useDispatch();
  useEffect(() => {
    if (statusGroup !== EnumStatisticStatusGroup.DELIVERED) {
      return;
    }
    dispatch(
      actionGroupByChange(
        statusGroup,
        (cookie.get(
          "statistic.chart." + statusGroup + ".groupBy"
        ) as EnumStatisticChartGroupBy) ??
          EnumStatisticChartGroupBy.CREATED_DATE
      )
    );
  }, [statusGroup]);
  if (statusGroup !== EnumStatisticStatusGroup.DELIVERED) {
    return null;
  }
  const handlerSelect = (groupBy: EnumStatisticChartGroupBy) => {
    dispatch(actionGroupByChange(statusGroup, groupBy));
    loading({ groupBy });
    cookie.set("statistic.chart." + statusGroup + ".groupBy", groupBy, {
      expires: 10 * 365,
    });
  };
  return (
    <MenuButton
      ButtonProps={{
        size: "small",
        variant: "outlined",
        color: "primary",
        disabled: isLoading,
      }}
      active={groupBy ?? EnumStatisticChartGroupBy.CREATED_DATE}
      items={[
        {
          label: "Дате заказа",
          code: EnumStatisticChartGroupBy.CREATED_DATE,
          onClick: () => handlerSelect(EnumStatisticChartGroupBy.CREATED_DATE),
        },
        {
          label: "Дате доставки",
          code: EnumStatisticChartGroupBy.DELIVERED_DATE,
          onClick: () =>
            handlerSelect(EnumStatisticChartGroupBy.DELIVERED_DATE),
        },
      ]}
    />
  );
};

export default SelectorGroupBy;
